import { activationStrategy } from "aurelia-router";
import { Client } from "../../../views/app/client/client";
import { NotificationType } from "../../../services/basics/notification-client.service";
import { LotteryKeyHelper } from "../../../services/modules/brand-client.service";
var BaseNavigationMenu = /** @class */ (function () {
    function BaseNavigationMenu(router, gamePlayerTicketService, eventAggregator, tokenClient, notificationClientService, i18n, lotteryClientService, dialogClientService) {
        this.router = router;
        this.gamePlayerTicketService = gamePlayerTicketService;
        this.tokenClient = tokenClient;
        this.notificationClientService = notificationClientService;
        this.i18n = i18n;
        this.lotteryClientService = lotteryClientService;
        this.menu = [];
        eventAggregator.subscribe(Client.UpdatePurchaseCount, this.setPurchaseCount.bind(this));
    }
    BaseNavigationMenu.prototype.setCartTop = function (x) {
        this.cartTop = x;
    };
    BaseNavigationMenu.prototype.setCartCount = function (x) {
        this.cartCount = x;
    };
    BaseNavigationMenu.prototype.setPurchaseCount = function () {
        var _this = this;
        if (this.tokenClient.user && this.tokenClient.user.isAuthenticated) {
            this.gamePlayerTicketService.getPurchasesNotificationCount().then(function (x) {
                _this.purchaseCount = x;
            }).catch(function (x) {
                _this.notificationClientService.show("Error", _this.i18n.tr(_this.getLotteryKey + "-" + x.response), NotificationType.Error);
            });
        }
    };
    BaseNavigationMenu.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    BaseNavigationMenu.prototype.getLotteryKey = function (name) {
        var key = name ? LotteryKeyHelper.getKey(name) : '';
        return key;
    };
    return BaseNavigationMenu;
}());
export { BaseNavigationMenu };
